function SequencingRule (ConditionCombination, Action, RuleConditions) {
    this.ConditionCombination = ConditionCombination;
    this.Action = Action;
    this.RuleConditions = RuleConditions;
}

SequencingRule.prototype = {
    toString: function () {
        var ret = "If " + this.ConditionCombination + " condition(s) evaluate to true, then " + this.Action + ".  ",
            condition;

        if (this.RuleConditions.length > 1) {
            ret += "Conditions: ";

            for (condition in this.RuleConditions) {
                if (this.RuleConditions.hasOwnProperty(condition)) {
                    ret += "{" + condition + "} " + this.RuleConditions[condition] + "; ";
                }
            }
        }
        else {
            ret += "Condition: " + this.RuleConditions[0];
        }

        return ret;
    }
};
